<template>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-tooltip bottom v-if="delIFRSClsGrp">
          <v-btn text icon color="red" v-on="on" @click="doPromptRemove">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <span>Delete IFRS Class Group</span>
        </v-tooltip>
        <v-icon v-else>{{ getIcon(mode) }}</v-icon>
        <v-toolbar-title>{{ getHeaders(mode) }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 v-if="newIFRSClsGrp">
              <v-text-field
                    v-model="ifrsClsGrpForm.ifrsClsGrp"
                    :label="labels.ifrsClsGrp"
                    :error-messages="errors.collect('ifrsClsGrp')"
                    data-vv-name="ifrsClsGrp"
                    :data-vv-as="labels.ifrsClsGrp"
                    v-validate="'required|param|max:4'"
                  ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{ labels.ifrsClsGrp }}</v-subheader>
              <div class="queryValue">{{ ifrsClsGrpForm.ifrsClsGrp }}</div>
            </v-flex>
            <v-flex xs12 v-if="hideField">
              <v-text-field
                    v-model="ifrsClsGrpForm.ifrsClsGrpDesc"
                    :label="labels.ifrsClsGrpDesc"
                    :error-messages="errors.collect('ifrsClsGrpDesc')"
                    data-vv-name="ifrsClsGrpDesc"
                    :data-vv-as="labels.ifrsClsGrpDesc"
                    v-validate="'required'"
                  ></v-text-field>
            </v-flex>
            <v-flex xs12 v-else>
              <v-subheader class="queryLabel">{{ labels.ifrsClsGrpDesc }}</v-subheader>
              <div class="queryValue">{{ ifrsClsGrpForm.ifrsClsGrpDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ ifrsClsGrpForm.createdName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(ifrsClsGrpForm.createdDate) }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="!newIFRSClsGrp">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ ifrsClsGrpForm.modifiedName }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ formatDisplayDate(ifrsClsGrpForm.modifiedDate) }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="close()">Cancel</v-btn>
        <v-btn v-if="hideField" color="primary" text @click.native="doSave">{{ mode === 'new' ? 'Save' : 'Update' }}</v-btn>
      </v-card-actions>
      <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records.</confirm>
    </v-card>
  </template>
<script>
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    ifrsClsGrpForm: Object,
    menu: Object,
    mode: String
  },
  data() {
    return {
      labels: {
        ifrsClsGrp: 'IFRS Class Group',
        ifrsClsGrpDesc: 'IFRS Class Group Description',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      newIFRSClsGrp: false,
      delIFRSClsGrp: false,
      promptRemove: false,
      submitting: false
    }
  },
  watch: {
    mode: function (value) {
      this.doModeInit()
    }
  },
  computed: {
    hideField() {
      return this.newIFRSClsGrp || this.mode === 'edit'
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    doModeInit() {
      this.resetMessages()
      if (this.mode === 'new') {
        this.newIFRSClsGrp = true
        this.delIFRSClsGrp = false
        this.doInit()
      } else if (this.mode === 'delete') {
        this.newIFRSClsGrp = false
        this.delIFRSClsGrp = true
      } else {
        this.newIFRSClsGrp = false
        this.delIFRSClsGrp = false
      }
    },
    doInit() {
      this.resetMessages()
      this.ifrsClsGrpForm.ifrsClsGrp = null
      this.ifrsClsGrpForm.ifrsClsGrpDesc = null
      this.ifrsClsGrpForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.ifrsClsGrpForm.createdDate = new Date()
    },
    getHeaders(mode) {
      var header = ''
      if (mode === 'new') {
        header = 'New'
      } else if (mode === 'edit') {
        header = 'Edit'
      } else if (mode === 'query') {
        header = 'Query'
      } else if (mode === 'delete') {
        header = 'Delete'
      }
      return header + ' IFRS Class Group'
    },
    getIcon(mode) {
      var icon = ''
      if (mode === 'new') {
        icon = 'mdi-plus'
      } else if (mode === 'edit') {
        icon = 'mdi-pencil'
      } else if (mode === 'query') {
        icon = 'mdi-magnify'
      } else if (mode === 'delete') {
        icon = 'mdi-delete'
      }
      return icon
    },
    doPromptRemove() {
      this.promptRemove = true
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newIFRSClsGrp) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createIFRSClsGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.ifrsClsGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.errorMessage('Record already exists')
            // data.fieldMessages.map((field, index) => {
            //   const { message } = field
            //   this.errorMessage(message.message)
            // })
            // this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateIFRSClsGrp
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.ifrsClsGrpForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.close()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    close() {
      this.doInit()
      this.$emit('close')
    },
    async doRemove() {
      const apiURI = this.menu.deleteIFRSClsGrp
      if (apiURI) {
        this.$http
          .post(apiURI, this.ifrsClsGrpForm)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.close()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  created() {
    this.doModeInit()
  },
  mixins: [MessageMixin]
}
</script>
